import * as types from "../../store/mutation-types";
import { getCourses, submitCousre } from "../../store/api/api";
// import axios from "axios";
const state = {
  courses: [],

  course: {},
  quizzes: [],
  data_quiz: [],
  answers_by_driver: [],
  data_answer: {
    form: []
  },
  // token: "",
  course_id: null,
  data_video: {},
  data_lesson: {},
  score: 0,

  submit_status: "", // loading - success - error

  // times_submitted: null // count amount of submiting
};

const getters = {
  // token: state => state.token,
  courses: state => state.courses,

  course: state => state.course,
  answers: state => state.answers_by_driver,
  quizzes: state => state.quizzes,
  video: state => state.data_video,
  lesson: state => state.data_lesson,
  getSubmitStatus: state => state.submit_status,
  // getTimesSubmitted: state => state.times_submitted,

  filterData: (state) => {
    let data = []

    state.courses.forEach(value => {
      value.courses.forEach(item => data.push(item))
    })

    const filteredData = data.reduce((acc, current) => {
      const x = acc.find(item => item._id === current._id);
      if (!x) {
        return acc.concat([current]);
      } else {
        return acc;
      }
    }, []);

    return filteredData
  },

  requiredCourses: (state, rootState) => {
    let data = getters.filterData(state)
    let courses = data.filter(e => e.required === true)

    const exam = rootState && rootState.supplierProfile && rootState.supplierProfile.extra && rootState.supplierProfile.extra.exam
    if (exam && exam.length > 0) {
      courses.forEach(course => {
        course.score = 0
        exam.forEach(e => {
          if (e.course_id === course._id) {
            course.score = e.score > course.score  ? e.score : course.score
          }
        })
        
        course.is_passed = course.required && course.score >= course.passing_score
      })
    }
    return courses
  },
  notRequiredCourses: state => {
    let data = getters.filterData(state)
    return data.filter(e => e.required !== true)
  },
  nextStepButtonVisible: (state, rootState) => {
    const requiredCourses = getters.requiredCourses(state, rootState)
    let result = !requiredCourses.some(c => !c.is_passed)
    return result
  }
};
const actions = {
  getAllCourses({ commit }, token) {
    return new Promise((resolve, reject) => {
      getCourses({ token: token })
        .then(response => {

          commit(types.SET_COURSES, response.data);
          resolve(response);
          
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  getCourse({ commit, state }, slug) {
    let filterData = getters.filterData(state)
    let dataCourse = filterData.find(e => e.slug === slug);
    dataCourse && dataCourse.steps.forEach(step => {
      if (step.type === "video") {
        commit(types.SET_DATA_VIDEO, step);
      } else if (step.type === "iframe") {
        commit(types.SET_DATA_LESSON, step);
      } else if (step.type === "assessment") {
        commit(types.FETCH_QUIZ, step);
      }
    });
    commit(types.SET_COURSE, dataCourse);
  },

  getCourseById({ commit, state }, course_id) {
    state.course_id = course_id;
    let dataCourse = state.courses.find(e => e._id == course_id);
    dataCourse && 
    dataCourse.steps.forEach(step => {
      if (step.type === "video") {
        commit(types.SET_DATA_VIDEO, step);
      } else if (step.type === "iframe") {
        commit(types.SET_DATA_LESSON, step);
      } else if (step.type === "assessment") {
        commit(types.FETCH_QUIZ, step);
      }
    });
    commit(types.SET_COURSE, dataCourse);
  },

  addScore({ commit, state }) {
    state.score += 1;
    commit(types.SET_SCORE, state.score);
  },

  addDriverAnswer({ commit }, data) {
    commit(types.SET_ANSWER_BY_DRIVER, data);
  },
  // eslint-disable-next-line
  async submitAnswers({}, token) {
    state.data_answer.form = JSON.stringify([state.answers_by_driver]);
    if (token) {
      state.data_answer.token = token;
      state.submit_status = "loading";
      const option = state.data_answer;

      await submitCousre(option)
        .then(() => {
          state.submit_status = "success";
        })
        .catch(err => {
          state.submit_status = "error";
          console.log(err);
        });
    }
  },

  resetData() {
    (state.data_quiz = []), (state.answers_by_driver = []), (state.score = 0);
  }
};
const mutations = {
  [types.SET_COURSES](state, data) {
    state.courses = data;
  },
  [types.SET_COURSE](state, data) {
    state.course = data;
  },

  [types.FETCH_QUIZ](state, data) {
    // shuffle questions

    function shuffle(a, b, c, d) {
      c = a.length;
      while (c)
        (b = (Math.random() * (--c + 1)) | 0),
          (d = a[c]),
          (a[c] = a[b]),
          (a[b] = d);
    }
    shuffle(data.questions);

    data.questions.forEach(value => {
      shuffle(value.answers);
    });

    state.quizzes = data;
  },

  [types.SET_SCORE](state, data) {
    state.score = data;
  },

  [types.SET_ANSWER_BY_DRIVER](state, data) {
    state.answers_by_driver = data;
  },

  [types.SET_DATA_LESSON](state, data) {
    state.data_lesson = data;
  },

  [types.SET_DATA_VIDEO](state, data) {
    state.data_video = data;
  },

  [types.SET_DATA_QUIZ](state, data) {
    state.data_quiz = data;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
